import React from 'react';

import { Table } from 'react-bootstrap';

const UsersCountTable = (props) => {
    const rows = props.counters.map(counters => {
        return (
            <tr key={counters.name}>
                <td><strong>{counters.name}</strong></td>
                <td>{counters.subscribed}</td>
                <td>{counters.unsubscribed}</td>
                <td>{counters.total}</td>
            </tr>
        );
    });

    return (
        <Table bordered responsive>
            <thead>
                <tr>
                    <th>Domain</th>
                    <th>Subscribed</th>
                    <th>Unsubscribed</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
}

export default UsersCountTable;


// WEBPACK FOOTER //
// ./src/scenes/UsersCount/components/UsersCountTable/index.js